var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mb-4" }, [
    _c("div", { staticClass: "flex flex-row" }, [
      _c(
        "div",
        { staticClass: "flex flex-row items-center" },
        [
          _c("UserIcon", { staticClass: "pr-2 w-auto h-auto" }),
          _c(
            "span",
            {
              staticClass:
                "text-primary-black font-400 text-sm pr-2 customWhiteSpace",
            },
            [_vm._v("Suggested resources")]
          ),
        ],
        1
      ),
      _vm.resourcesExist
        ? _c("div", [
            _c("div", { staticClass: "flex flex-row items-center relative" }, [
              _c("div", { staticClass: "skills-chip-plus" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.resourcesCount.length > 10 ? "+" : "") +
                    _vm._s(_vm.resourcesCount) +
                    " "
                ),
              ]),
              _c(
                "button",
                {
                  staticClass:
                    "text-base text-blue font-medium pl-4 cursor-pointer",
                  on: { click: _vm.showTooltip },
                },
                [_vm._v(" View resources ")]
              ),
              _c(
                "div",
                { staticClass: "flex flex-col bg-white" },
                [
                  _vm.isTooltipVisible
                    ? _c("SuggestedResourcesModal", {
                        attrs: {
                          name: this.name,
                          skillIds: _vm.skillIds,
                          suitableContractors: _vm.suitableContractors,
                        },
                        on: { close: _vm.hideTooltip },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ])
        : _c("div", { staticClass: "text-storm-gray text-sm font-medium" }, [
            _vm._v("n/a"),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }